import { clsx } from 'clsx'
import { Link } from 'react-router'

export interface BreadcrumbItemProps {
  href: string;
  children: string;
  isActive?: boolean;
  isConsumerSize?: boolean;
  className?: string;
  id?: string;
  textEllipsis?: boolean
}

export const BreadcrumbItem = ({
  href,
  children,
  isActive = false,
  className,
  id,
  textEllipsis = false
}: BreadcrumbItemProps) => (
  <li
    id={id}
    className={clsx(
      'md:text-body2 sm:text-body3-mobile py-[1px] md:py-0 items-center max-w-full whitespace-nowrap',
      "last:after:content-none after:content-['/'] after:text-neutral-80 dark:after:text-neutral-30 after:mx-1.5",
      textEllipsis ? 'overflow-hidden text-ellipsis' : '',
      className
    )}
  >
    <Link
      to={href}
      className={clsx(
        isActive ? 'pointer-events-none text-neutral-80 dark:text-neutral-30' : 'text-consumer-blue hover:text-[#004E9D] dark:text-dark-consumer-blue dark:hover:text-[#75BAFF] hover:underline')}
      aria-disabled={isActive}
    >
      {children}
    </Link>
  </li>
)